<template>
  <div>
    <ul class="videoUL">
      <li
        class="wow animate__slideInUp"
        :data-wow-delay="`${idx / 10}s`"
        :key="idx"
        v-for="(item, idx) in videoList"
      >
        <!-- <el-image
            class="videoImg"
            :src="require('@/assets/img/news.jpg')"
            fit="cover"
          ></el-image> -->
        <video class="videoImg" :src="item.Url" controls="controls"></video>
        <span>{{ item.Title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["videoList"],
  components: {},
};
</script>

<style lang="scss">
.videoUL {
  margin: 50px 0 20px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 20px 20px;
  li {
    .videoImg {
      height: 380px;
      width: 100%;
      object-fit: cover;
    }
    span {
      padding: 10px 0;
      display: block;
      font-size: 18px;
    }
  }
}
</style>